<div *ngIf="fetching" class="fetching-files">
    <mat-spinner></mat-spinner>
</div>
<div id="deals-container" class="deals-container">
    <ng-container *ngTemplateOutlet="selectedDealId ? singleDeal : multipleDeals"></ng-container>
</div>

<ng-template #singleDeal>
    <ng-container *ngTemplateOutlet="showCreateEditUser ? createUserForm : null"> </ng-container>
    <div *ngIf="!showCreateEditUser" class="wrapper-div">
        <div class="page-title-actions">
            <div class="title-actions">
                <span class="title">{{ selectedDeal?.name }}</span>
                <div class="actions">
                    <app-button
                        data-testid="deal-activity-button"
                        (clicked)="dealActivityClick()"
                        buttonClass="secondary"
                        label="Deal Activity"
                    />
                    <app-button
                        *ngIf="canAccessImpersonateDealDashboard()"
                        data-testid="deal-dashboard-button"
                        (clicked)="dealDashboardClick()"
                        buttonClass="secondary"
                        label="View in Deal Dashboard"
                    />
                </div>
            </div>
        </div>
        <div class="frame-div">
            <div class="deal-details-div">
                <div class="deal-details-scroll">
                    <div class="event-div">
                        <div class="event-date-div">
                            <span class="event-month">{{ selectedDeal?.closingDt | date: 'MMM' : 'UTC' }}</span>
                            <span class="event-day">{{ selectedDeal?.closingDt | date: 'dd' : 'UTC' }}</span>
                        </div>
                        <div class="event-date-event">
                            <span class="event-label">Closing Date</span>
                            <span class="event-date-full">{{
                                selectedDeal?.closingDt | date: 'MMM dd, yyyy' : 'UTC'
                            }}</span>
                        </div>
                    </div>
                    <div class="info-div">
                        <div class="info-label">
                            {{ 'Deal Info' | uppercase }}
                        </div>
                        <div class="info-data">
                            <span class="info-data-label">Project Name</span>
                            <span class="info-data-value">{{ selectedDeal?.projectName }}</span>
                        </div>
                        <div class="info-data">
                            <span class="info-data-label">Selling Company</span>
                            <span class="info-data-value">{{ selectedDeal?.seller }}</span>
                        </div>
                        <div class="info-data">
                            <span class="info-data-label">Acquiring Company</span>
                            <span class="info-data-value">{{ selectedDeal?.buyer }}</span>
                        </div>
                        <div class="info-data">
                            <span class="info-data-label">Salesforce ID</span>
                            <span
                                class="as-link"
                                (click)="openInNewTab($event, getDealSfUrl(selectedDeal?.sfId))"
                                [matTooltip]="getDealSfUrl(selectedDeal?.sfId)"
                                matTooltipPosition="below"
                                matTooltipShowDelay="300"
                                matTooltipHideDelay="200"
                                >{{ selectedDeal?.sfId }}</span
                            >
                        </div>
                        <div class="info-data">
                            <span class="info-data-label">NetSuite ID</span>
                            <span
                                class="as-link"
                                (click)="openInNewTab($event, getDealNsUrl(selectedDeal?.nsId))"
                                [matTooltip]="getDealNsUrl(selectedDeal?.nsId)"
                                matTooltipPosition="below"
                                matTooltipShowDelay="300"
                                matTooltipHideDelay="200"
                                >{{ selectedDeal?.nsId }}
                            </span>
                        </div>
                        <div class="info-data">
                            <span class="info-data-label">Subsidiary</span>
                            <span class="info-data-value" *ngFor="let sub of selectedDeal?.subsidiaries">{{
                                sub
                            }}</span>
                        </div>
                    </div>
                    <div class="team-div">
                        <div class="team-label">
                            {{ 'Team' | uppercase }}
                        </div>
                        <div class="team-list">
                            <div class="team-data">
                                <span class="team-data-label">Relationship Manager</span>
                                <span class="team-data-value">{{ selectedDeal?.rmName }}</span>
                            </div>
                            <div class="team-data">
                                <span class="team-data-label">Relationship Associate</span>
                                <span class="team-data-value">{{ selectedDeal?.raName }}</span>
                            </div>
                            <div class="team-data">
                                <span class="team-data-label">Business Development</span>
                                <span class="team-data-value">{{ selectedDeal?.bdName }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="services-div">
                        <div class="services-label">
                            {{ 'Services' | uppercase }}
                        </div>
                        <div class="services-column">
                            <span class="service-label" *ngFor="let service of selectedDeal?.services">{{
                                service
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="users-section-div">
                <mat-tab-group
                    *ngIf="canAccessTabDD() || canAccessTabSH()"
                    [disableRipple]="true"
                    [(selectedIndex)]="selectedIndexSingleDeal"
                    (selectedTabChange)="tabChangeSingleDeal($event)"
                    animationDuration="0ms"
                    class="tool-bar"
                    fitInkBarToContent="true"
                    mat-align-tabs="start"
                    mat-stretch-tabs="false"
                >
                    <mat-tab *ngIf="canAccessTabDD()" label="Deal Dashboard">
                        <ng-container *ngTemplateOutlet="dealDashboardUserTableTemplate"></ng-container>
                    </mat-tab>
                    <mat-tab *ngIf="canAccessTabSH()" label="Shareholder Portal">
                        <ng-container *ngTemplateOutlet="shareholderPortalUserTableTemplate"></ng-container>
                    </mat-tab>
                </mat-tab-group>
                <div *ngIf="showAddUserMenu()" class="add-user-absolute-position">
                    <div [matMenuTriggerFor]="menu">
                        <app-button label="Add User" [showDisclosure]="true" />
                    </div>
                </div>
                <mat-menu #menu="matMenu" xPosition="before" yPosition="below">
                    <div
                        *appAccessCheckSection="permissionCreateUser"
                        mat-menu-item
                        class="menu-option"
                        (click)="showCreateEditUserPanel()"
                    >
                        Create User
                    </div>
                    <div
                        *appAccessCheckSection="permissionAddUser"
                        mat-menu-item
                        class="menu-option"
                        (click)="showAddExistingUserPanel()"
                    >
                        Add Existing User
                    </div>
                </mat-menu>
            </div>
        </div>
    </div>
</ng-template>

<ng-template matTabContent #dealDashboardUserTableTemplate>
    <div class="users-frame-div">
        <div class="users-search-bar">
            <app-user-access-search
                [initialValue]="singleDealSearchHelpers[tabSingleDealUserHelper].requestHelper.srchVal"
                data-testid="app-accounts-search-users"
                placeholder="Filter by name, email, or role..."
                (newSearchEvent)="performSearch($event)"
            >
            </app-user-access-search>
        </div>
    </div>
    <div class="table-container">
        <app-user-table
            class="users-table"
            data-testid="app-user-table"
            [displayedColumns]="userDisplayedColumns"
            [showCreateUser]="showCreateEditUser"
            (userToEditEvent)="handleUserToEditEvent($event)"
            [userRecords]="singleDealSearchHelpers[tabSingleDealUserHelper].records"
            [initialSort]="{
                id: singleDealSearchHelpers[tabSingleDealUserHelper].requestHelper.sortField,
                start: singleDealSearchHelpers[tabSingleDealUserHelper].requestHelper.sortDir
            }"
            [searchText]="singleDealSearchHelpers[tabSingleDealUserHelper].requestHelper.srchVal"
            [page]="singleDealSearchHelpers[tabSingleDealUserHelper].requestHelper.page"
            [pageSize]="singleDealSearchHelpers[tabSingleDealUserHelper].requestHelper.size"
            [totalRecords]="singleDealSearchHelpers[tabSingleDealUserHelper].totalRecordCount"
            (pageEvent)="handlePageEvent($event)"
            (sortEvent)="handleSortChange($event, 0)"
            (userActionNav)="handleUserAction($event)"
        ></app-user-table>
<!--            (revokeAccessEvent)="handleRevokeAccessEventDD($event)"-->
<!--            [showRevokeAccess]="showRevokeAccess"-->
    </div>
</ng-template>

<ng-template matTabContent #shareholderPortalUserTableTemplate>
    <div class="users-frame-div">
        <div class="users-search-bar">
            <app-user-access-search
                [initialValue]="singleDealSearchHelpers[tabShareholderUserAccessHelper].requestHelper.srchVal"
                data-testid="app-accounts-search-users"
                placeholder="Filter by name, permission, or shareholder..."
                (newSearchEvent)="performSearch($event)"
            >
            </app-user-access-search>
        </div>
    </div>
    <div class="table-container">
        <app-shareholder-user-access-table
            class="shareholder-user-access-table"
            [displayedColumns]="shareholderDealUserDisplayedColumns"
            [records]="singleDealSearchHelpers[tabShareholderUserAccessHelper].records"
            [initialSort]="{
                id: singleDealSearchHelpers[tabShareholderUserAccessHelper].requestHelper.sortField,
                start: singleDealSearchHelpers[tabShareholderUserAccessHelper].requestHelper.sortDir
            }"
            [searchText]="singleDealSearchHelpers[tabShareholderUserAccessHelper].requestHelper.srchVal"
            [searchFields]="sharpAuthSearchFields"
            [page]="singleDealSearchHelpers[tabShareholderUserAccessHelper].requestHelper.page"
            [pageSize]="singleDealSearchHelpers[tabShareholderUserAccessHelper].requestHelper.size"
            [totalRecords]="singleDealSearchHelpers[tabShareholderUserAccessHelper].totalRecordCount"
            [fetching]="fetching"
            [showImpersonateUser]="showImpersonateUser"
            (userClickedEvent)="handleUserClickedEventDealsUsers($event)"
            (shareholderClickedEvent)="handleShareholderClickedEventDealsUsers($event)"
            (pageEvent)="handlePageEvent($event)"
            (sortEvent)="handleSortChange($event, 1)"
            (revokeAccessEvent)="handleRevokeAccessEventSH($event)"
        ></app-shareholder-user-access-table>
<!--            [showRevokeAccess]="showRevokeAccess"-->
    </div>
</ng-template>

<ng-template #multipleDeals>
    <div id="header-bar" class="header-bar">
        <div class="header-text-div">
            <span id="header-text" class="header-text">Deals</span>
        </div>
    </div>
    <div class="main">
        <div id="search-bar" class="search-bar">
            <app-user-access-search
                [initialValue]="multipleDealSearchHelper.requestHelper.srchVal"
                data-testid="app-accounts-search"
                placeholder="Filter Deals"
                (newSearchEvent)="performSearch($event)"
            ></app-user-access-search>
        </div>
        <div class="table-container">
            <app-deal-table
                class="deals-table"
                data-testid="app-deals-table"
                [displayedColumns]="multipleDealsDisplayedColumns"
                [dealRecords]="multipleDealSearchHelper.records"
                [initialSort]="{
                    id: multipleDealSearchHelper.requestHelper.sortField,
                    start: multipleDealSearchHelper.requestHelper.sortDir
                }"
                [searchText]="multipleDealSearchHelper.requestHelper.srchVal"
                [page]="multipleDealSearchHelper.requestHelper.page"
                [pageSize]="multipleDealSearchHelper.requestHelper.size"
                [totalRecords]="multipleDealSearchHelper.totalRecordCount"
                (pageEvent)="handlePageEvent($event)"
                (sortEvent)="handleSortChange($event, null)"
                [fetching]="fetching"
                (dealActivityNav)="handleDealActivityNavigation($event)"
                (dealDashboardNav)="handleDealDashboardNavigation($event)"
            ></app-deal-table>
        </div>
    </div>
</ng-template>

<ng-template #createUserForm>
    <app-create-edit-user
        id="create-edit-user"
        [mode]="createEditUserMode"
        [userToEditId]="userToEditId"
        (showCreateEditUserCloseEvent)="handleShowCreateEditUserCancelEvent()"
    ></app-create-edit-user>
</ng-template>
